import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-w-jierujiedian",
  "use": "icon-w-jierujiedian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-w-jierujiedian\"><path d=\"M704 640v64h32c38.4 0 64 25.6 64 64v128c0 38.4-25.6 64-64 64h-128c-38.4 0-64-25.6-64-64v-128c0-38.4 25.6-64 64-64h32v-64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64h640c38.4 0 64 25.6 64 64v448c0 38.4-25.6 64-64 64h-128z m-576 192c0-19.2 12.8-32 32-32H320v-83.2s51.2 38.4 160 115.2C371.2 915.2 320 953.6 320 953.6v-89.6H160c-19.2 0-32-12.8-32-32z m576-192h-64 64zM204.8 140.8v428.8h620.8V140.8H204.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol